/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateful
 */
import React from 'react';
import CheckinCalculationTable from './tables/checkinCalculationTable';
import ClockCardCalculationTable from './tables/clockCardCalculationTable';

import './Modal.scss'

class ModalContent extends React.Component {
  constructor(props){
    super(props)
  }

  render() {
    const { salaryCalculatorType } = this.props;
    
    return (
      <div className='salary-modal-content'>
        <div className='container-fluid'>
          <p>{__('Please fill the fields you need for the calculation.', 'teacherAttendance')}</p>
          { salaryCalculatorType === 'checkin' &&
            <CheckinCalculationTable {...this.props} />
          }
          { salaryCalculatorType === 'clockCard' &&
            <ClockCardCalculationTable {...this.props} />
          }
        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/Salary/ModalContent.js